import React from 'react';
import { getCurrentSlideImageSize } from 'app/stores/selectors';
import { CropView } from './CropView';
export const ProjectCrop = () => (React.createElement(CropView, { cacheStateKey: "unifiedArea", itemSelector: getCurrentSlideImageSize }));
